import { Controller } from "@hotwired/stimulus"

import { writePagePath } from "../lib/page_path"

// A plain two-panel tab switch: the buttons carry `data-name`, the panels
// carry the same, and the controller shows the one that matches. State rides
// on `data-on` like the Map/List toggle (see partners_view_controller), so the
// buttons are declared identically in the markup.
//
// The hash is honoured on connect and written on every switch: this page gets
// linked to mid-session ("open the collab tab"), and a tab that resets to the
// first panel on reload loses the reader's place.
export default class extends Controller {
  static targets = ["tab", "panel"]
  // The tab shown first when the address names none; the first tab otherwise.
  // On a creator's page the tab lives in the path (lib/page_path), not the hash.
  static values = { default: String }

  select(event) {
    const name = event.params.name
    this.show(name)
    this.element.dataset.urlTab = name
    if (!writePagePath(this.element)) history.replaceState(null, "", `#${name}`)
  }

  show(name) {
    this.panelTargets.forEach((p) => p.classList.toggle("hidden", p.dataset.name !== name))
    this.tabTargets.forEach((t) => { t.dataset.on = String(t.dataset.name === name) })
  }

  connect() {
    const wanted = this.element.dataset.pageBase ? "" : location.hash.slice(1)
    const known = this.tabTargets.some((t) => t.dataset.name === wanted)
    this.show(known ? wanted : this.defaultValue || this.tabTargets[0]?.dataset.name)
  }
}
